<template lang="pug">
.features
  bw-features
  

</template>

<script>
import BwFeatures from "@/components/chunks/BwFeatures";
export default {
  components: {
    BwFeatures
  }
};
</script>

<style lang="stylus" scoped></style>
